module.exports = __webpack_public_path__ + "static/img/4945_phase_function_Paper_PointsHejduk_Prediction.bd13b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4945_phase_function_Paper_PointsHejduk_Prediction.png
// module id = WZ22
// module chunks = 0